<div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
  <div class="no-data center-shimmer">
    @if (type=='default') {
    <div class="lottie-animation mt-10">
      <!-- <ng-lottie [height]="'150px'" [options]="options" (animationCreated)="onAnimate($event)"> </ng-lottie> -->
    </div>
    }
    @if (type=='loading') {
    <div class="lottie-animation mt-10">
      <!-- <ng-lottie [height]="'150px'" [options]="options" (animationCreated)="onAnimate($event)"> </ng-lottie> -->

    </div>

    <!-- <div id="default">
      <div class="loader-1">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div> -->
    }
    <div class="loader">
      <div class="loading-text">
        {{ message }}
        @if (type=='loading') {
        <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
        }
      </div>
    </div>
  </div>
</div>